import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));
export const CarbonPage = Loadable(lazy(() => import('../pages/dashboard/carbon/CarbonPage')));
export const ChartsPage = Loadable(lazy(() => import('../pages/dashboard/charts/Charts')));
export const ProgramAndVolets = Loadable(lazy(() => import('../pages/dashboard/ProgramAndVolet')));
export const CarbonStatsPage = Loadable(
  lazy(() => import('../pages/dashboard/carbonStats/CarbonStats'))
);
export const HistoryPage = Loadable(lazy(() => import('../pages/dashboard/History/History')));
export const IndicatorsTablePage = Loadable(
  lazy(() => import('../pages/dashboard/indicateurs/IndicatorsPage'))
);
export const IndicatorsPage = Loadable(
  lazy(() => import('../pages/dashboard/folders/IndicatorsPage'))
);
export const ActivityPage = Loadable(
  lazy(() => import('../pages/dashboard/activity/ActivityPage'))
);
export const PageSix = Loadable(lazy(() => import('../pages/PageSix')));

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const GeneralAppPage = Loadable(lazy(() => import('../pages/dashboard/GeneralAppPage')));

// User
export const UserListPage = Loadable(lazy(() => import('../pages/dashboard/user/UserListPage')));
export const UserCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/user/UserCreatePage'))
);
export const UserEditPage = Loadable(lazy(() => import('../pages/dashboard/user/UserEditPage')));
export const FolderListPage = Loadable(
  lazy(() => import('../pages/dashboard/folders/FoldersListPage'))
);
